var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { staticClass: "w100" },
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.title))]),
      _c(
        "w-card-content",
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "6" } },
                [
                  _c("w-checkbox", {
                    attrs: {
                      value: _vm.checkboxValue,
                      label: _vm.$ct("show-cover-image"),
                    },
                    on: {
                      input: function ($event) {
                        return _vm.setCheckboxValue($event)
                      },
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "6" } },
                [
                  _c(
                    "w-link",
                    {
                      staticClass: "right",
                      on: {
                        click: function ($event) {
                          _vm.editStyle = true
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$ct("edit-style")))]
                  ),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "6" } },
                [
                  _c("w-input-number", {
                    attrs: { label: _vm.$ct("cell-width"), fancy: "" },
                    model: {
                      value: _vm.settings.Width,
                      callback: function ($$v) {
                        _vm.$set(_vm.settings, "Width", $$v)
                      },
                      expression: "settings.Width",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "6" } },
                [
                  _c("w-input-number", {
                    attrs: { label: _vm.$ct("cell-height"), fancy: "" },
                    model: {
                      value: _vm.settings.Height,
                      callback: function ($$v) {
                        _vm.$set(_vm.settings, "Height", $$v)
                      },
                      expression: "settings.Height",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-modal",
        { attrs: { value: _vm.editStyle } },
        [
          _vm.editStyle
            ? _c("app-image-style-editor", {
                attrs: { value: _vm.settings },
                on: {
                  close: function ($event) {
                    _vm.editStyle = false
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }